import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CompetitionList from "./List";
import CompetitionCreate from "./Create";
import CompetitionEdit from "./Edit";
import CompetitionShow from "./Show";

export const resources = {
  isMenu: true,
  icon: <AutoAwesomeIcon />,
  name: "competitions",
  title: "Конкурси",
  list: <CompetitionList />,
  create: <CompetitionCreate />,
  edit: <CompetitionEdit />,
  show: <CompetitionShow />,
  permission: "competitions",
};
